import React from "react";
import "./ArticleDetailBanner.css";
import RichTextContent, { CmsText } from "../../../../RichTextContent/RichTextContent";

import bgImage from "../../../../../assets/images/services/hero.png";

const ArticleDetailBanner = ({ article }) => {
  return (
    <section className="articledetail">

      {/* BACKGROUND IMAGE */}
      <img src={bgImage} alt="" className="articledetail__bg" />

      {/* OVERLAY */}
      <div className="articledetail__overlay" />

      {/* CONTENT */}
      <div className="articledetail__content">

        <span className="articledetail__meta">
          Published <CmsText content={article?.date} as="span" />
        </span>

        <CmsText content={article?.title} as="h1" />

        <RichTextContent content={article?.desc} />

      </div>

    </section>
  );
};

export default ArticleDetailBanner;